import { Tooltip,  TooltipProps } from '@mui/material';
import { ReactElement } from 'react';

interface CustomTooltipProps extends TooltipProps{
    children: ReactElement;     
    title: string;                 
    offsetX?: number;               
    offsetY?: number;      
    fontSize?: string;
}
const CustomTooltip: React.FC<CustomTooltipProps> = ({ children, title, offsetX=0, offsetY=0 }) => {
    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <Tooltip
            title={title}
            arrow
            placement='left'
            slotProps={{
                popper: {
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [offsetX, offsetY], //x,y
                            },
                        },
                    ],
                },
                tooltip: {          // ✅ Add font size here
                    sx: { fontSize: "14px" }  // Custom font size
                }
            }}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;